import React from 'react';
import { Navigate } from 'react-router-dom';
import withSidebar from '../components/HOC/withSidebar';
import routeNames from '../constants/routeNames';

const Home: React.FC = () => <Navigate to={routeNames.users()} />;

export default withSidebar(Home);
